import { businessBaseURL } from "./base";
var baseURL = businessBaseURL + "/employee";
export var employee = {
    timetables: {
        index: function () { return baseURL + "/timetables"; },
    },
};
